import PropTypes from 'prop-types';
import SearchOption from '../../../shared/components/SearchOption/SearchOption';
import SearchOptionButton from '../../../shared/components/SearchOption/SearchOptionButton';
import { TripLengthFieldOverlay } from './TripLengthFieldOverlay';

export const TripLengthField = ({
  header,
  overlayTitle,
  tripLengthsTitle,
  isOpen,
  isOtherActive,
  selected,
  tripLengths,
  onClose,
  onChange,
}) => {
  return (
    <SearchOption>
      <SearchOptionButton header={header} isOpen={isOpen} isOtherActive={isOtherActive} testSelector="lms-triplength">
        {selected ? selected.displayName : ''}
      </SearchOptionButton>
      <TripLengthFieldOverlay
        isOpen={isOpen}
        onClose={onClose}
        header={overlayTitle}
        title={tripLengthsTitle}
        tripLengths={tripLengths}
        selected={selected}
        onClick={onChange}
      />
    </SearchOption>
  );
};

TripLengthField.propTypes = {
  header: PropTypes.string,
  tripLengthsTitle: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.shape({ displayName: PropTypes.string, value: PropTypes.number }),
  tripLengths: PropTypes.array,
  overlayTitle: PropTypes.node,
  isOpen: PropTypes.bool,
  isOtherActive: PropTypes.bool,
  onClose: PropTypes.func,
};
